var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productsOverLimitWithLegacySubscriptionBanner" },
    [
      _vm.ShowProductsOverLimitWithLegacySubscriptionBannerEnabled
        ? _c(
            "b-row",
            [
              _c(
                "b-alert",
                {
                  staticClass: "flex-grow-1 w-100",
                  attrs: {
                    show:
                      _vm.ShowProductsOverLimitWithLegacySubscriptionBannerEnabled,
                    variant: "info"
                  }
                },
                [
                  _c("h5", [
                    _c("i", { staticClass: "far fa-info-circle fa-lg" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("xWeHaveUpdatedOurProductLimits"))
                    )
                  ]),
                  _c("p", { staticClass: "bannerBody ml-4" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "xProductsOverLimitWithLegacySubscriptionExistingUser"
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "p-0 fw-bold learnMore hoverPointer",
                        on: {
                          click: function($event) {
                            return _vm.$bvModal.show(
                              "products-over-limit-with-legacy-subscription-modal"
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("xLearnMoreLowercase")) + ".")]
                    )
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "products-over-limit-with-legacy-subscription-modal",
            centered: "",
            size: "lg"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c(
                    "b-row",
                    {
                      staticClass: "w-100 justify-content-between py-0",
                      attrs: { "align-v": "center", "no-gutters": "" }
                    },
                    [
                      _c("h2", { staticClass: "modal-title" }, [
                        _c("i", { staticClass: "far fa-info-circle fa-md" }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("xWeHaveUpdatedOurProductLimits"))
                        )
                      ]),
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "btn btn-icon-button btn-icon-button--gray",
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "secondary",
                        "data-test-hook": "contact-support-button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.navToSupportPage()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xContactSupport")) + " ")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        "data-test-hook": "done-button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", [
            _c("p", { staticClass: "mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("xProductsOverLimitWithLegacySubscriptionExistingUser")
                )
              )
            ]),
            _c("strong", [_vm._v(_vm._s(_vm.$t("xPleaseNote")))]),
            _c(
              "ul",
              _vm._l(2, function(n) {
                return _c("li", { key: n }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        `xProductsOverLimitWithLegacySubscriptionModalItem${n}`
                      )
                    )
                  )
                ])
              }),
              0
            ),
            _c("p", { staticClass: "mt-4" }, [
              _vm._v(_vm._s(_vm.$t("xThankYouForBeingAValuedUser")))
            ]),
            _c("p", { staticClass: "mt-4" }, [
              _vm._v(_vm._s(_vm.$t("xIfYouHaveQuestionsContactSupport")))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }